import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LoaderService } from './../../service/loader.service';
import { NotificationService, LanguageService, ServiceProviderCaseService, AuthService, RepairerCaseService } from './../../../modules/api';
import { MessagingService } from './../../service/messaging.service';
import { TranslateService } from '@ngx-translate/core';
import { CaseStateService } from './../../service/state.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  user;
  showLoader: boolean;
  overwrite = true;
  total = 0;
  route = '';
  viewOnly = false;
  caseCount = <any>{
    NewUnAssigned: 0,
    Pending: 0,
    Received: 0,
    Repairing: 0,
    Delayed: 0,
    PaymentWaiting: 0,
    Finished: 0,
    Returned: 0,
    Closed: 0,
    Importance: 0,
    All: 0
  };
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private ns: NotificationService,
    private message: MessagingService,
    private cs: ServiceProviderCaseService,
    private as: AuthService,
    private translate: TranslateService,
    private rcs: RepairerCaseService,
    private caseStateService: CaseStateService
  ) {
    const cachedCount = localStorage.getItem('totalCase');
    if (cachedCount) {
      try {
        this.caseCount = { ...this.caseCount, ...JSON.parse(cachedCount) };
      } catch (e) {}
    }

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (this.router.url.search('cases') >= 0) {
          this.route = this.translate.instant('CASES');
        }
        if (this.router.url.search('dashboard') >= 0) {
          this.route = this.translate.instant('DASHBOARD');
        }
        if (this.router.url.search('messages') >= 0) {
          this.route = this.translate.instant('MESSAGES');
        }
        if (this.router.url.search('customers') >= 0) {
          this.route = this.translate.instant('CUSTOMERS');
        }
        if (this.router.url.search('repairer') >= 0) {
          this.route = this.translate.instant('REPAIRERS');
        }
        if (this.router.url.search('reports') >= 0) {
          this.route = this.translate.instant('REPORT_STATISTIC');
        }
        if (this.router.url.search('settings') >= 0) {
          this.route = this.translate.instant('SETTINGS');
        }
      }
    });
    setInterval(() => {
      this.overwrite = false;
      this.loadCounts();
    }, 300000);

  }

  ngOnInit() {
    this.getProfile();
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.loaderService.overwrite.subscribe((val: boolean) => {
      this.overwrite = val;
    });
    this.message.totalNoti.subscribe(
      data => {
        this.total = data;
      }
    );

    this.caseStateService.countUpdate$.subscribe(update => {
      if (update && update.status && this.caseCount[update.status] !== undefined) {
        this.caseCount[update.status] = update.count;
        localStorage.setItem('totalCase', JSON.stringify(this.caseCount));
      }
    });

    this.caseStateService.refreshCount$.subscribe(trigger => {
      if (trigger) {
        this.loadCounts();
      }
    });

    this.loadCounts();
  }

  loadCounts() {
    if (this.user && this.user.type !== 'Repairer' && this.user.type !== 'RepairShop') {
      this.cs.apiServiceProviderCasesCountTotalCasesGet()
        .subscribe(data => {
          this.caseCount = data;
          localStorage.setItem('totalCase', JSON.stringify(this.caseCount));
        });
    } else if (this.user && this.user.type === 'Repairer') {
      this.fetchRepairerCounts();
    }
  }

  fetchRepairerCounts() {
    const statuses: string[] = [
      'Pending',
      'Received',
      'Repairing',
      'Delayed',
      'PaymentWaiting',
      'Finished',
      'Returned',
      'Closed'
    ];

    const requests = statuses.map(status =>
      this.rcs.apiRepairerCasesMyCasesByRequestTypeGet({
        caseStatus: status as any,
        page: 1,
        limit: 1,
        caseRequest: 'All' as any,
        servicePlace: 'All' as any
      }).pipe(
        catchError(() => of({ total: 0, data: [] }))
      )
    );

    forkJoin(requests).subscribe(results => {
      results.forEach((res, index) => {
        const status = statuses[index];
        this.caseCount[status] = res && typeof res.total === 'number' ? res.total : 0;
      });
      localStorage.setItem('totalCase', JSON.stringify(this.caseCount));
    });
  }

  getProfile() {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    if (this.user.type === 'Repairer') {
      this.viewOnly = true;
    }
  }
}
